export default __webpack_public_path__ + "static/media/NikhilGahlot.e01788f6.png";